import { LoginOutput } from '@allocab/allocab-commons-shared-types';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { clearTokens, updateTokens } from './auth';
import { queryKeys } from '../datastore';
import { storage } from '../storage';

const fetchTokens = () => storage.getJSONItem<LoginOutput>('tokens');

export const useTokens = () => {
  const { data: tokens, isFetched } = useQuery({
    queryKey: queryKeys.tokens(),
    queryFn: fetchTokens,
    staleTime: Infinity,
    gcTime: Infinity,
    networkMode: 'always',
  });

  useEffect(() => {
    if (tokens !== undefined) {
      storage.setJSONItem('tokens', tokens);
    }
  }, [tokens]);

  return { tokens, updateTokens, clearTokens, isFetched };
};
